import React, { useState, useEffect } from 'react';
import axios from 'axios';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _capitalize from 'lodash/capitalize';
import { Link, useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Accordion from '@material-ui/core/Accordion';
import Typography from '@material-ui/core/Typography';
import DoneIcon from '@material-ui/icons/Done';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import ClearIcon from '@material-ui/icons/Clear';
import { Favorite, Share, ExpandMore, MoreVert, Add } from '@material-ui/icons';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
  faTimesCircle,
  faSadTear,
  faGrinBeam
} from '@fortawesome/free-solid-svg-icons';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Alert, Form, Table, Modal } from 'react-bootstrap';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
// import { AppBar, Tab, Tabs } from '@material-ui/core';
import Header from '../../header/Header';
import { Container, Wrapper, HomeButtons } from '../../../styles/HomeStyles';
import { FormWrapper, Label } from '../../../styles/LoginStyles';

import {
  DashboardWrapper,
  TableWrapper,
  ButtonWrapper,
  ContentWrapper,
  TextWrapper,
  ControlButtonWrapper,
  ActionButtons,
  UserLabel,
  NormalText,
  AlertWrapper
} from '../../../styles/DashboardStyles';
// import { TabPanel, a11yProps } from '../../instructor/Home';
import { config } from '../../../config';
import { styles } from '../../../styles/TabStyles';
import '../../../Translations/i18n';
import { Toast } from '../../student/Home';

const useStyles = makeStyles(theme => ({
  tabTextColor: {
    backgroundColor: '#4287cc'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function AdminDashboard() {
  const history = useHistory();
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabValue, setValue] = useState(0);
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [status, setStatus] = useState('');
  const [pendingCourses, setPendingCourses] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [approvedCourses, setApprovedCourses] = useState([]);
  const [pendingAdminStatus, setpendingAdminStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [approveModalShow, setApproveModalShow] = React.useState(false);
  const [declineModalShow, setDeclineModalShow] = React.useState(false);
  const [suggestSuccessModalShow, setSuccessModalShow] = React.useState(false);
  const [currentName, setCurrentName] = useState('');
  const [reason, setReason] = useState('');
  const [showReason, setShowReason] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [sectionExpanded, setSectionExpanded] = useState(false);
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');
  const { t } = useTranslation();

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSectionAccordionChange = panel => (event, isSectionExpanded) => {
    setSectionExpanded(isSectionExpanded ? panel : false);
  };

  const [suggestInputShow, setSuggestInputShow] = React.useState(false);

  useEffect(() => {
    const uid = localStorage.getItem('userId');
    axios
      .all([
        axios.get(`${config.API_URL}course/admin/pendingCourses`),
        axios.get(`${config.API_URL}course/admin/approvedCourses`),
        axios.get(`${config.API_URL}user/auth/admin/${uid}/mySuggestedAdmins`),
        axios.get(`${config.API_URL}user/auth/view-users/${uid}`)
      ])
      .then(
        axios.spread((obj1, obj2, obj3, obj4) => {
          setPendingCourses(_get(obj1, 'data.data', []));
          setApprovedCourses(_get(obj2, 'data.data', []));
          setpendingAdminStatus(_get(obj3, 'data.data', []));
          setAllUsers(_get(obj4, 'data.data', []));
        })
      );
  }, [isLoading, status, alertSuccess]);

  const ApproveModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Approved!
          </Modal.Title>
          <FontAwesomeIcon size="2x" icon={faGrinBeam} />
        </Modal.Header>
        <Modal.Body>
          <p>{`You have successfully approved the course request for ${currentName} !`}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const DeclineModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Declined!
          </Modal.Title>
          <FontAwesomeIcon size="2x" icon={faSadTear} />
        </Modal.Header>
        <Modal.Body>
          <p>{`You have successfully declined the course request for ${currentName} !`}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderAllUsers = () => {
    return (
      <TabPanel>
        <React.Fragment>
          <UserLabel>All Users</UserLabel>
          {_size(allUsers) === 0 && (
            <div>
              <center>
                <FontAwesomeIcon size="3x" icon={faTimesCircle} />
              </center>
              <NormalText>No Users</NormalText>
            </div>
          )}
          {_size(allUsers) > 0 && (
            <TableWrapper>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Paid</th>
                    <th>Banned</th>
                    {/* <th>Pending</th> */}
                    <th>Verified</th>
                  </tr>
                </thead>
                <tbody>
                  {allUsers.map((index, key) => {
                    return (
                      <>
                        <tr>
                          <td>{key + 1}</td>
                          <td>{index.name}</td>
                          <td>{index.email}</td>
                          <td>{index.phone}</td>
                          <td>{index.paid ? <DoneIcon /> : <ClearIcon />}</td>
                          <td>{index.is_ban ? <DoneIcon /> : <ClearIcon />}</td>
                          {/* <td>
                            {index.is_pending ? <DoneIcon /> : <ClearIcon />}
                          </td> */}
                          <td>
                            {index.is_verified ? <DoneIcon /> : <ClearIcon />}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          )}
        </React.Fragment>
      </TabPanel>
    );
  };

  const SuggestSuccessModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Suggested!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You have successfully submitted a new admin request. Please wait for
            the approval!
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const submitEmail = () => {
    setSuggestInputShow(false);
    const suggestData = {
      email,
      SuggestionDescription: description,
      userid: localStorage.getItem('userId')
    };
    console.log(suggestData, 'emailData');
    axios
      .post(`${config.API_URL}user/auth/admin/suggest`, suggestData)
      .then(response => {
        console.log(_get(response, 'data.data', []), 'yaha');
        if (_get(response, 'data.data.error', false)) {
          setStatus('There waas an issue suggesting an admin');
          setAlertFailure(true); // setErrorMsg(_get(response, 'data.data.error', []));
        }
        if (_get(response, 'data.data.suggested', false)) {
          setStatus(
            'You have successfully submitted a new admin request. Please wait for the approval!'
          );
          setAlertSuccess(true);
        }
      })
      .catch(error => {
        console.log(error, 'email errr');
      });
  };

  const SuggestAdminInput = () => {
    return (
      <div>
        <FormWrapper>
          <Form>
            <Form.Group controlId="emailId">
              <Label>{t('Email')}</Label>
              <Form.Control
                type="text"
                name="email"
                placeholder="Enter email"
                value={email}
                onChange={e => setEmail(e.currentTarget.value)}
              />
              <Label>{t('specifyreasonadminsuggestion')}</Label>
              <TextareaAutosize
                aria-label="minimum height"
                style={{ width: 400, height: 150 }}
                rowsMin={3}
                value={description}
                onChange={e => setDescription(e.target.value)}
                placeholder={t('EnterReason')}
              />
            </Form.Group>
          </Form>
        </FormWrapper>
        <Button
          variant="contained"
          color="primary"
          disabled={email === '' || description === ''}
          onClick={() => submitEmail()}
        >
          Submit
        </Button>
      </div>
    );
  };

  const approveCourse = (index, key) => {
    setIsLoading(true);
    axios
      .post(`${config.API_URL}course/admin/course/approve`, {
        courseid: index.courseid,
        adminComment: reason,
        approve: 1
      })
      .then(response => {
        console.log(response, 'approve data');
        setCurrentName(index.name);
        setStatus(
          `You have successfully approved the course request for ${currentName} !`
        );
        setAlertSuccess(true);
        // setApproveModalShow(true);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error, 'errr');
        setIsLoading(false);
      });
  };

  const declineCourse = index => {
    setIsLoading(true);
    axios
      .post(`${config.API_URL}course/admin/course/approve`, {
        courseid: index.courseid,
        adminComment: reason,
        approve: 0
      })
      .then(response => {
        console.log(response, 'decline data');
        setIsLoading(false);
        setCurrentName(index.name);
        setStatus(
          `You have successfully declined the course request for ${currentName} !`
        );
        setAlertFailure(true);
        // setDeclineModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setIsLoading(false);
      });
  };

  const handleValueChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderSuggestAdmin = () => {
    return (
      <TabPanel>
        <React.Fragment>
          <center>
            <SuggestAdminInput />
            <UserLabel>{t('SuggestedAdminStatus')}</UserLabel>
            <TableWrapper>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t('AdminName')}</th>
                    <th>{t('Email')}</th>
                    <th>{t('Statusofrequest')}</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingAdminStatus.map((index, key) => {
                    return (
                      <>
                        <tr>
                          <td>{key + 1}</td>
                          <td>{index.name}</td>
                          <td>{index.email}</td>
                          <td>{index.suggestStatus}</td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          </center>
        </React.Fragment>
      </TabPanel>
    );
  };

  const renderPendingCourses = () => {
    return (
      <TabPanel>
        <React.Fragment>
          <UserLabel>{t('Coursesthatrequireyourapproval')}</UserLabel>
          <>
            {_size(pendingCourses) === 0 && (
              <div>
                <center>
                  <FontAwesomeIcon size="3x" icon={faTimesCircle} />
                </center>
                <NormalText>{t('NoPendingcourseapprovalrequests')}</NormalText>
              </div>
            )}
            {_size(pendingCourses) > 0 && (
              <TableWrapper>
                <NormalText>{t('approveordeclinethecourse')}</NormalText>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t('CourseName')}</th>
                      <th>{t('CourseDescription')}</th>
                      <th>{t('Actions')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingCourses.map((index, key) => {
                      return (
                        <>
                          <tr>
                            <td>{key + 1}</td>
                            <td>{index.name}</td>
                            <td>{index.description}</td>
                            <td>
                              <ControlButtonWrapper>
                                <ActionButtons
                                  success
                                  onClick={() => setShowReason(`approve${key}`)}
                                  // onClick={() => approveCourse(index, key)}
                                >
                                  {t('Approve')}
                                </ActionButtons>
                                <ActionButtons
                                  onClick={() => setShowReason(`decline${key}`)}
                                  // onClick={() => declineCourse(index)}
                                >
                                  {t('Decline')}
                                </ActionButtons>
                              </ControlButtonWrapper>
                              {(showReason === `approve${key}` ||
                                showReason === `decline${key}`) && (
                                <React.Fragment>
                                  <TextField
                                    required
                                    id="standard-required"
                                    label={`${
                                      showReason === `approve${key}`
                                        ? 'Approval'
                                        : 'Decline'
                                    } Reason`}
                                    error={reason === ''}
                                    errorText="Reason is required"
                                    value={reason}
                                    onChange={e => setReason(e.target.value)}
                                  />
                                  <div>
                                    <Button
                                      style={{ marginTop: 10 }}
                                      onClick={() =>
                                        showReason === `approve${key}`
                                          ? approveCourse(index, key)
                                          : declineCourse(index)
                                      }
                                      variant="contained"
                                      color="primary"
                                      disabled={reason === ''}
                                    >
                                      SEND
                                    </Button>
                                  </div>
                                </React.Fragment>
                              )}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </Table>
              </TableWrapper>
            )}
          </>
        </React.Fragment>
      </TabPanel>
    );
  };

  const renderApprovedCourseAccordion = () => {
    return (
      <React.Fragment>
        <center>
          {approvedCourses.map((index, key) => {
            return (
              <Accordion
                expanded={expanded === `panel${key}`}
                style={{ width: '70%' }}
                onChange={handleAccordionChange(`panel${key}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>
                    <b>{index.name}</b>
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <b>{index.description}</b>
                  </Typography>
                </AccordionSummary>
                {index.section.map((sec, secKey) => {
                  return (
                    <center>
                      <Accordion
                        expanded={sectionExpanded === `panel${secKey}`}
                        style={{ width: '70%' }}
                        onChange={handleSectionAccordionChange(
                          `panel${secKey}`
                        )}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography className={classes.heading}>
                            <b>{sec.name}</b>
                          </Typography>
                          <Typography className={classes.secondaryHeading}>
                            <b>{sec.description}</b>
                          </Typography>
                        </AccordionSummary>
                        {_size(sec.lecture) === 0 ? (
                          <AccordionDetails>
                            {t('Thissectionhasnolectures')}
                          </AccordionDetails>
                        ) : (
                          <React.Fragment>
                            {sec.lecture.map(lec => {
                              return (
                                <AccordionDetails>
                                  <a
                                    className={classes.heading}
                                    href={lec.link}
                                    target="_blank"
                                  >
                                    {lec.name}
                                  </a>
                                  <Typography
                                    className={classes.secondaryHeading}
                                  >
                                    {lec.description}
                                  </Typography>
                                </AccordionDetails>
                              );
                            })}
                          </React.Fragment>
                        )}
                      </Accordion>
                    </center>
                  );
                })}
              </Accordion>
            );
          })}
        </center>
      </React.Fragment>
    );
  };

  const submitSuggestCategory = () => {
    const suggestCategoryData = {
      name: categoryName,
      description: categoryDescription,
      userid: localStorage.getItem('userId')
    };
    axios
      .post(`${config.API_URL}course/admin/addCategory`, suggestCategoryData)
      .then(response => {
        setCategoryDescription('');
        setCategoryName('');
        setStatus(`${categoryName} suggested successfully!`);
        setAlertSuccess(true);
      })
      .catch(error => {
        setStatus('There was a problem suggesting the category');
        setAlertFailure(true);
        console.log(error, 'email errr');
      });
  };

  const renderSuggestCategory = () => {
    return (
      <TabPanel>
        <React.Fragment>
          <center>
            <div>
              <FormWrapper>
                <Form>
                  <Form.Group controlId="emailId">
                    <Label>{t('CategoryName')}</Label>
                    <TextareaAutosize
                      aria-label="minimum height"
                      style={{ width: 400, height: 150 }}
                      rowsMin={3}
                      value={categoryName}
                      onChange={e => setCategoryName(e.target.value)}
                      placeholder={t('CategoryName')}
                    />
                    <Label>{t('EnterCategoryDescription')}</Label>
                    <TextareaAutosize
                      aria-label="minimum height"
                      style={{ width: 400, height: 150 }}
                      rowsMin={3}
                      value={categoryDescription}
                      onChange={e => setCategoryDescription(e.target.value)}
                      placeholder={t('CategoryDescription')}
                    />
                  </Form.Group>
                </Form>
              </FormWrapper>
              <Button
                variant="contained"
                color="primary"
                disabled={categoryName === '' || categoryDescription === ''}
                onClick={() => submitSuggestCategory()}
              >
                Submit
              </Button>
            </div>
          </center>
        </React.Fragment>
      </TabPanel>
    );
  };

  const renderApprovedCourses = () => {
    return (
      <TabPanel>
        <React.Fragment>
          <UserLabel>{t('AllCourses')}</UserLabel>
          {_size(approvedCourses) === 0 && (
            <div>
              <center>
                <FontAwesomeIcon size="3x" icon={faTimesCircle} />
              </center>
              <NormalText>{t('Nocourses')}</NormalText>
            </div>
          )}
          {renderApprovedCourseAccordion()}
        </React.Fragment>
      </TabPanel>
    );
  };

  const handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    setAlertFailure(false);
    setAlertSuccess(false);
  };

  return (
    <Container>
      <DashboardWrapper>
        <Header setTabIndex={() => setTabIndex(0)} />
      </DashboardWrapper>
      <ContentWrapper>
        <Snackbar
          open={alertFailure}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="error">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={alertSuccess}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="success">
            {status}
          </Toast>
        </Snackbar>
        {/* <AppBar position="static">
          <Tabs
            style={{ backgroundColor: 'black' }}
            value={tabValue}
            onChange={handleValueChange}
            aria-label="simple tabs example"
          >
            <Tab label="Pending Courses" {...a11yProps(0)} />
            <Tab label="Approved Courses" {...a11yProps(1)} />
            <Tab label="Suggest Admin" {...a11yProps(2)} />
          </Tabs>
        </AppBar> */}
        <Tabs
          selectedIndex={tabIndex}
          onSelect={index => setTabIndex(index)}
          selectedTabClassName={classes.tabTextColor}
        >
          <TabList style={styles.tabList}>
            <Tab style={styles.tabs}>{t('PENDINGCOURSES')}</Tab>
            <Tab style={styles.tabs}>{t('APPROVEDCOURSES')}</Tab>
            <Tab style={styles.tabs}>{t('SUGGESTADMIN')}</Tab>
            <Tab style={styles.tabs}>{t('ALLUSERS')}</Tab>
            <Tab style={styles.tabs}>{t('SUGGESTCATEGORY')}</Tab>
          </TabList>

          {renderPendingCourses()}
          {renderApprovedCourses()}
          {renderSuggestAdmin()}
          {renderAllUsers()}
          {renderSuggestCategory()}
        </Tabs>
      </ContentWrapper>
      {/* <ApproveModal
        show={approveModalShow}
        onHide={() => setApproveModalShow(false)}
      />
      <DeclineModal
        show={declineModalShow}
        onHide={() => setDeclineModalShow(false)}
      />
      <SuggestSuccessModal
        show={suggestSuccessModalShow}
        onHide={() => setSuccessModalShow(false)}
      /> */}
    </Container>
  );
}
